import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';
@Component({
  selector: 'app-k12-and-elearning',
  templateUrl: './k12-and-elearning.component.html',
  styleUrls: ['./k12-and-elearning.component.scss']
})
export class K12AndElearningComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka 企業版｜K-12 與數位學習解決方案");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 的先進 AI 不僅能協助學生提升寫作能力，更在寫作過程中引導他們學習正確的學術寫作規範。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka 企業版｜K-12 與數位學習解決方案" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 的先進 AI 不僅能協助學生提升寫作能力，更在寫作過程中引導他們學習正確的學術寫作規範。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/k12-and-elearning' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/k12-and-elearning' });

  }
  
  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/paterson.png", "altText": "paterson" },
    { "imgSrc": "/assets/images/client_logos/abraham-lincoln.png", "altText": "abraham lincoln" },
    { "imgSrc": "/assets/images/client_logos/act.png", "altText": "act" },
    { "imgSrc": "/assets/images/client_logos/AguaFriaUnion.png", "altText": "agua fria union" },
    { "imgSrc": "/assets/images/client_logos/almosa.png", "altText": "almosa" },
    { "imgSrc": "/assets/images/client_logos/amalAcademy.png", "altText": "amal academy" },
    { "imgSrc": "/assets/images/client_logos/AmericanschoolofDubai.png", "altText": "American school of Dubai" },
    { "imgSrc": "/assets/images/client_logos/lusaka.png", "altText": "lusaka" }
  ];

}
